<div class="header">
  <div class="title">Disposition Group</div>
  <button class="close-button" mat-icon-button (click)="discard()" [tabIndex]="-1">
    <mat-icon [svgIcon]="'close'"></mat-icon>
  </button>
</div>
<mat-horizontal-stepper linear="true" #stepper>
  <mat-step [stepControl]="groupNameForm" state="assignment">
    <form [formGroup]="groupNameForm">
      <ng-template matStepLabel>Group Name</ng-template>
      <mat-form-field>
        <mat-label>Name</mat-label>
        <input matInput placeholder="Group Name" formControlName="name" required autocomplete="off" />
      </mat-form-field>
      <mat-form-field>
        <mat-label>Note</mat-label>
        <input matInput placeholder="Note" formControlName="description" autocomplete="off" />
      </mat-form-field>
      <div style="display: flex; justify-content: flex-end">
        <button [color]="'primary'" mat-flat-button matStepperNext>Next</button>
        <button
          [color]="'primary'"
          mat-flat-button
          style="margin-left: 10px"
          [disabled]="groupNameForm.pristine || groupNameForm.invalid"
          DebounceClick
          (debounceLoading)="isDebounceLoading($event)"
          (debounceClick)="save()"
        >
          <span *ngIf="!isLoading">Finish</span>
          <mat-progress-spinner *ngIf="isLoading" [diameter]="24" [mode]="'indeterminate'"></mat-progress-spinner>
        </button>
      </div>
    </form>
  </mat-step>
  <mat-step [stepControl]="buyersBrokerForm" state="contacts">
    <ng-template matStepLabel>Buyer's Broker</ng-template>
    <add-contact [parentForm]="buyersBrokerForm"></add-contact>
    <div style="display: flex; justify-content: space-between">
      <div style="display: flex; justify-content: flex-start">
        <button [color]="'primary'" mat-button matStepperPrevious>Back</button>
      </div>
      <div style="display: flex; justify-content: flex-end">
        <button [color]="'primary'" mat-button matStepperNext>Skip</button>
        <button
          [disabled]="
            buyersBrokerForm.value.name === '' ||
            (!buyersBrokerForm.value.category_id && buyersBrokerForm.value.id === '')
          "
          [color]="'primary'"
          mat-flat-button
          matStepperNext
          (click)="addContact(buyersBrokerForm)"
        >
          Add Contact
        </button>
        <button
          [color]="'primary'"
          mat-flat-button
          style="margin-left: 10px"
          DebounceClick
          (debounceLoading)="isDebounceLoading($event)"
          (debounceClick)="save()"
        >
          <span *ngIf="!isLoading">Finish</span>
          <mat-progress-spinner *ngIf="isLoading" [diameter]="24" [mode]="'indeterminate'"></mat-progress-spinner>
        </button>
      </div>
    </div>
  </mat-step>
  <mat-step [stepControl]="sellersBrokerForm" state="contacts">
    <ng-template matStepLabel>Seller's Broker</ng-template>
    <add-contact [parentForm]="sellersBrokerForm"></add-contact>
    <div style="display: flex; justify-content: space-between">
      <div style="display: flex; justify-content: flex-start">
        <button [color]="'primary'" mat-button matStepperPrevious>Back</button>
      </div>
      <div style="display: flex; justify-content: flex-end">
        <button [color]="'primary'" mat-button matStepperNext>Skip</button>
        <button
          [disabled]="
            sellersBrokerForm.value.name === '' ||
            (!sellersBrokerForm.value.category_id && sellersBrokerForm.value.id === '')
          "
          [color]="'primary'"
          mat-flat-button
          matStepperNext
          (click)="addContact(sellersBrokerForm)"
        >
          Add Contact
        </button>
        <button
          [color]="'primary'"
          mat-flat-button
          style="margin-left: 10px"
          DebounceClick
          (debounceLoading)="isDebounceLoading($event)"
          (debounceClick)="save()"
        >
          <span *ngIf="!isLoading">Finish</span>
          <mat-progress-spinner *ngIf="isLoading" [diameter]="24" [mode]="'indeterminate'"></mat-progress-spinner>
        </button>
      </div>
    </div>
  </mat-step>
  <mat-step [stepControl]="buyerForm" state="contacts">
    <ng-template matStepLabel>Buyer</ng-template>
    <add-contact [parentForm]="buyerForm"></add-contact>
    <div style="display: flex; justify-content: space-between">
      <div style="display: flex; justify-content: flex-start">
        <button [color]="'primary'" mat-button matStepperPrevious>Back</button>
      </div>
      <div style="display: flex; justify-content: flex-end">
        <button
          [disabled]="buyerForm.value.name === '' || (!buyerForm.value.category_id && buyerForm.value.id === '')"
          [color]="'primary'"
          mat-flat-button
          matStepperNext
          (click)="addContact(buyerForm, true)"
        >
          Add Contact & Finish
        </button>
        <button
          [color]="'primary'"
          mat-flat-button
          style="margin-left: 10px"
          DebounceClick
          (debounceLoading)="isDebounceLoading($event)"
          (debounceClick)="save()"
        >
          <span *ngIf="!isLoading">Finish</span>
          <mat-progress-spinner *ngIf="isLoading" [diameter]="24" [mode]="'indeterminate'"></mat-progress-spinner>
        </button>
      </div>
    </div>
  </mat-step>
  <ng-template matStepperIcon="contacts">
    <mat-icon>assignment_ind</mat-icon>
  </ng-template>
  <ng-template matStepperIcon="assignment">
    <mat-icon>assignment</mat-icon>
  </ng-template>
</mat-horizontal-stepper>
